import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;

const defaultStartDate = new Date().toLocaleDateString('en-GB').split(',')[0];
const defaultEndDate = new Date().toLocaleDateString('en-GB').split(',')[0];

const CustomDatePicker = props => {
    return (
        <RangePicker
            className={props.className}
            style={props.style}
            defaultValue={[props.startDate || '', props.endDate || '']}
            format={dateFormat}
            value={[(props.startDate && dayjs(props.startDate, dateFormat)) || '', (props.endDate && dayjs(props.endDate, dateFormat)) || '']}
            onChange={(value, dateString) => {
                props.onChange(dateString);
            }}
            size={props?.size || 'small'}
        />
    );
};

export default CustomDatePicker;
